export default __webpack_public_path__ + "static/media/hero-desktop-safari-EN.b1e506bd.png";